import { Injectable } from "@angular/core";
import { IID_EP_RICHIESTA_PERMESSO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "../action/action.service";
import { CrudService } from "../crudService";
import { ProjectEntityStoreStrategy } from "../updateStoreStrategies";
import { IIDEpRichiestaQuery } from "./iidEPRichiesta.query";
import { IIDEpRichiestaStore } from "./iidEPRichiesta.store";
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
    providedIn: 'root'
  })
  @InterfaceDataService(InterfaceName.RICHIESTA_PERMESSO)
  export class IIDEpRichiestaService extends CrudService<IID_EP_RICHIESTA_PERMESSO, IIDEpRichiestaStore, IIDEpRichiestaQuery> {
    constructor(
      protected store: IIDEpRichiestaStore,
      public query: IIDEpRichiestaQuery,
      protected actionService: ActionService,
      protected updateStrategy: ProjectEntityStoreStrategy,
    ) {
      super(
        Topics.IID_EP_RICHIESTA_PERMESSO,
        store,
        query,
        actionService,
        updateStrategy
      );
    }
  }
